document.addEventListener("DOMContentLoaded", function () {

document.querySelectorAll(".sale-timer").forEach(function(timer){

const start = new Date(timer.dataset.start).getTime();
const end = new Date(timer.dataset.end).getTime();

if(isNaN(start) || isNaN(end)) return;

function update(){

const now = new Date().getTime();

if(now < start){
timer.style.display = "none";
return;
}

const total = end - start;
const left = end - now;

if(left <= 0){

if(timer.dataset.hide === "true"){
timer.style.display = "none";
} else {
timer.querySelector(".sale-countdown").innerHTML = "<b>ENDED</b>";
}

return;
}

timer.style.display = "block";

const d = Math.floor(left / (1000*60*60*24));
const h = Math.floor((left % (1000*60*60*24)) / (1000*60*60));
const m = Math.floor((left % (1000*60*60)) / (1000*60));
const s = Math.floor((left % (1000*60)) / 1000);

timer.querySelector(".d").textContent = String(d).padStart(2,"0");
timer.querySelector(".h").textContent = String(h).padStart(2,"0");
timer.querySelector(".m").textContent = String(m).padStart(2,"0");
timer.querySelector(".s").textContent = String(s).padStart(2,"0");

const bar = timer.querySelector(".sale-progress-fill");

if(bar){
bar.style.width = (left / total) * 100 + "%";
}

}

update();
setInterval(update, 1000);

});

});